import { Modules } from ".."
export const SEARCH_FILTER_CHANGE_DATE = "SEARCH_FILTER_CHANGE_DATE"
export const SEARCH_FILTER_CHANGE_PAGE = "SEARCH_FILTER_CHANGE_PAGE"
export const SEARCH_FILTER_CHANGE_SEARCH = "SEARCH_FILTER_CHANGE_SEARCH"
export const SEARCH_FILTER_CHANGE_FILTER = "SEARCH_FILTER_CHANGE_FILTER"

// export const CHANGE_PAGE = "CHANGE_PAGE";

export const changeDate = (date: Date | string, path: Modules) => ({
  type: SEARCH_FILTER_CHANGE_DATE,
  payload: date,
  path: path,
})

export const changePage = (page: number | string, path: Modules) => ({
  type: SEARCH_FILTER_CHANGE_PAGE,
  payload: page,
  path,
})

export const changeSearch = (search: string, path: Modules) => ({
  type: SEARCH_FILTER_CHANGE_SEARCH,
  payload: search,
  path,
})

export const changeFilter = (filter: any, path: Modules) => ({
  type: SEARCH_FILTER_CHANGE_FILTER,
  payload: filter,
  path,
})
